import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import StarRating from "../../../../components/StarRating";
import { useDispatch, useSelector } from "react-redux";
import { setProfileInfo } from "../../../../features/candidate/personalSlice";
import Pencil from "../../../../images/pencil.png";
import { useCandidateForm } from "../../CandidateFormContext";
import { toast } from "react-toastify";

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isCreating, markTabComplete, hasUnsavedChanges, isSaving, saveAllChanges } = useCandidateForm();

  const {
    totalInterviews,
    activeInterviews,
    passedInterviews,
    failedInterviews,
    holdInterviews,
    lastInterviewOn,
    rating,
  } = useSelector((state) => state.personal.profile);

  const candidateId = useSelector(state => state.personal.candidateId);

  const [profileRating, setProfileRating] = useState(rating);

  const [profileData, setProfileData] = useState({
    totalInterviews,
    activeInterviews,
    passedInterviews,
    failedInterviews,
    holdInterviews,
    lastInterviewOn,
    rating,
  });


  const onRatingChange = (rating) => {
    setProfileData((pervData) => ({
      ...pervData,
      rating,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setProfileData((pervData) => ({
      ...pervData,
      [name]: value,
    }));
  };

  useEffect(() => {
    dispatch(setProfileInfo(profileData));
  }, [profileData, profileRating]);

  // Format date for input (YYYY-MM-DD)
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toISOString().split('T')[0];
  };

  // Handle Previous button click
  const handlePrevious = () => {
    navigate('/candidate/add-candidate/personal/professional');
  };

  // Handle Next button click
  const handleNext = () => {
    // In create mode, mark tab as complete (Profile has no required fields for new candidates)
    if (isCreating) {
      markTabComplete('profile');
    }
    // Navigate to next tab
    navigate('/candidate/add-candidate/personal/emergency-contacts');
  };

  return (
    <div className="">
      <div className="mt-5">
        <h3>Rating</h3>
        <StarRating
          fontSize={24}
          initialRating={rating}
          setProfileRating={setProfileRating}
          onRatingChange={onRatingChange}
        />
      </div>
      <from className="flex flex-col gap-y-6 mt-5 text-sm font-normal text-text-hint">
        <div className="grid grid-cols-4 gap-3">
          <div className="">
            <label className="">
              Total Interviews            </label>
            <div className="flex justify-center items-center px-3 py-2 mt-1 border border-neutral-500 rounded-lg h-10">
              <input
                onChange={handleChange}
                value={totalInterviews}
                name="totalInterviews"
                placeholder="Total Interviews"
                disabled={candidateId}
                maxLength={25}
                className="outline-none w-full text-black"
              />
              {!candidateId && <img src={Pencil} alt="pencil" />}
            </div>
          </div>
          <div className="">
            <label className="">
              Active Interviews            </label>
            <div className="flex justify-center items-center px-3 py-2 mt-1 border border-neutral-500 rounded-lg h-10">
              <input
                onChange={handleChange}
                value={activeInterviews}
                name="activeInterviews"
                placeholder="Active Interviews"
                disabled={candidateId}
                maxLength={25}
                className="outline-none w-full text-black"
              />
              {!candidateId && <img src={Pencil} alt="pencil" />}
            </div>
          </div>
        </div>
        <div className="grid grid-cols-4 gap-3">
          <div className="">
            <label className="">
              Passed Interviews            </label>
            <div className="flex justify-center items-center px-3 py-2 mt-1 border border-neutral-500 rounded-lg h-10">
              <input
                onChange={handleChange}
                value={passedInterviews}
                name="passedInterviews"
                placeholder="Passed Interviews"
                disabled={candidateId}
                maxLength={25}
                className="outline-none w-full text-black"
              />
              {!candidateId && <img src={Pencil} alt="pencil" />}
            </div>
          </div>
          <div className="">
            <label className="">
              Failed Interviews            </label>
            <div className="flex justify-center items-center px-3 py-2 mt-1 border border-neutral-500 rounded-lg h-10">
              <input
                onChange={handleChange}
                value={failedInterviews}
                name="failedInterviews"
                placeholder="Failed Interviews"
                disabled={candidateId}
                maxLength={25}
                className="outline-none w-full text-black"
              />
              {!candidateId && <img src={Pencil} alt="pencil" />}
            </div>
          </div>
        </div>
        <div className="grid grid-cols-4 gap-3">
          <div className="">
            <label className="">
              Interviews on Hold            </label>
            <div className="flex justify-center items-center px-3 py-2 mt-1 border border-neutral-500 rounded-lg h-10">
              <input
                onChange={handleChange}
                value={holdInterviews}
                name="holdInterviews"
                placeholder="Interviews on Hold"
                disabled={candidateId}
                maxLength={25}
                className="outline-none w-full text-black"
              />
              {!candidateId && <img src={Pencil} alt="pencil" />}
            </div>
          </div>
          <div className="max-w-xs">
            <label className="">
              Last Interviewed on            </label>
            <div className="flex justify-center items-center px-3 py-2 mt-1 border border-neutral-500 rounded-lg h-10">
              <input
                name="lastInterviewOn"
                value={formatDateForInput(lastInterviewOn)}
                type="date"
                disabled
                className="outline-none border-none w-full text-black bg-transparent"
              />
            </div>
          </div>
        </div>
      </from>
      <div className="w-full py-10 px-8 flex justify-end gap-5">
        <button
          onClick={handlePrevious}
          className="text-secondary-700 bg-white border border-secondary-700 py-2 px-5 rounded-full text-base hover:bg-gray-50 transition"
        >
          Previous
        </button>
        {!isCreating && hasUnsavedChanges && (
          <button
            disabled={isSaving}
            onClick={async () => {
              try {
                await saveAllChanges();
              } catch (e) {
                // error toast handled by context
              }
            }}
            className="text-white bg-green-600 py-2 px-5 rounded-full text-base hover:bg-green-700 transition disabled:opacity-50"
          >
            {isSaving ? 'Saving...' : 'Save'}
          </button>
        )}
        <button
          onClick={handleNext}
          className="text-white bg-secondary-700 py-2 px-5 rounded-full text-base hover:bg-secondary-800 transition"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Profile;
